// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-code-entry {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.code-entry-container {
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 100%;
  text-align: center;
}

.code-entry-header h1 {
  color: #333;
  margin-bottom: 10px;
  font-size: 2rem;
  font-weight: 700;
}

.code-entry-header p {
  color: #666;
  margin-bottom: 30px;
  font-size: 1.1rem;
  line-height: 1.5;
}

.code-entry-form {
  margin-bottom: 30px;
}

.code-input-group {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.code-input {
  flex: 1 1;
  padding: 15px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 2px;
  transition: border-color 0.3s ease;
}

.code-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.code-input::placeholder {
  color: #999;
  font-weight: normal;
  letter-spacing: normal;
}

.access-btn {
  padding: 15px 30px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  white-space: nowrap;
}

.access-btn:hover:not(:disabled) {
  background: #5a6fd8;
}

.access-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.error-message {
  background: #fee;
  color: #c33;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid #fcc;
  font-size: 14px;
}

.code-help {
  text-align: left;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #667eea;
}

.code-help h4 {
  color: #333;
  margin-bottom: 15px;
  font-size: 1.1rem;
}

.code-help ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.code-help li {
  color: #666;
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
  line-height: 1.4;
}

.code-help li:before {
  content: "•";
  color: #667eea;
  font-weight: bold;
  position: absolute;
  left: 0;
}

/* Responsive design */
@media (max-width: 600px) {
  .code-entry-container {
    padding: 30px 20px;
  }
  
  .code-entry-header h1 {
    font-size: 1.5rem;
  }
  
  .code-entry-header p {
    font-size: 1rem;
  }
  
  .code-input-group {
    flex-direction: column;
  }
  
  .code-input {
    font-size: 16px;
    padding: 12px;
  }
  
  .access-btn {
    padding: 12px 20px;
    font-size: 14px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/ClientCodeEntry.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;AACT;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".client-code-entry {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 20px;\n}\n\n.code-entry-container {\n  background: white;\n  border-radius: 12px;\n  padding: 40px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  max-width: 500px;\n  width: 100%;\n  text-align: center;\n}\n\n.code-entry-header h1 {\n  color: #333;\n  margin-bottom: 10px;\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.code-entry-header p {\n  color: #666;\n  margin-bottom: 30px;\n  font-size: 1.1rem;\n  line-height: 1.5;\n}\n\n.code-entry-form {\n  margin-bottom: 30px;\n}\n\n.code-input-group {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.code-input {\n  flex: 1;\n  padding: 15px;\n  border: 2px solid #e1e5e9;\n  border-radius: 8px;\n  font-size: 18px;\n  font-weight: 600;\n  text-align: center;\n  letter-spacing: 2px;\n  transition: border-color 0.3s ease;\n}\n\n.code-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.code-input::placeholder {\n  color: #999;\n  font-weight: normal;\n  letter-spacing: normal;\n}\n\n.access-btn {\n  padding: 15px 30px;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  white-space: nowrap;\n}\n\n.access-btn:hover:not(:disabled) {\n  background: #5a6fd8;\n}\n\n.access-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.error-message {\n  background: #fee;\n  color: #c33;\n  padding: 12px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  border: 1px solid #fcc;\n  font-size: 14px;\n}\n\n.code-help {\n  text-align: left;\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 8px;\n  border-left: 4px solid #667eea;\n}\n\n.code-help h4 {\n  color: #333;\n  margin-bottom: 15px;\n  font-size: 1.1rem;\n}\n\n.code-help ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.code-help li {\n  color: #666;\n  margin-bottom: 8px;\n  padding-left: 20px;\n  position: relative;\n  line-height: 1.4;\n}\n\n.code-help li:before {\n  content: \"•\";\n  color: #667eea;\n  font-weight: bold;\n  position: absolute;\n  left: 0;\n}\n\n/* Responsive design */\n@media (max-width: 600px) {\n  .code-entry-container {\n    padding: 30px 20px;\n  }\n  \n  .code-entry-header h1 {\n    font-size: 1.5rem;\n  }\n  \n  .code-entry-header p {\n    font-size: 1rem;\n  }\n  \n  .code-input-group {\n    flex-direction: column;\n  }\n  \n  .code-input {\n    font-size: 16px;\n    padding: 12px;\n  }\n  \n  .access-btn {\n    padding: 12px 20px;\n    font-size: 14px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
